import React from 'react'

// API đánh dấu phần in đậm bằng **…**; render bằng React nên không chèn HTML
const renderLine = (line) => line.split('**').map((part, index) => index % 2 ? <b key={index}>{part}</b> : part)

const InsightBlock = ({title, lines = []}) => (
    <div className="gen">
        <div className="gt">⟳ Nhận định tự sinh từ số liệu đang lọc</div>
        {title && <div className="o">{title}</div>}
        <ul>
            {lines.map((line, index) => <li key={index}>{renderLine(line)}</li>)}
        </ul>
    </div>
)

export default InsightBlock
